// Helpers d'AFFICHAGE du coût carburant par trajet (preview). Aucune logique de calcul ici :
// le backend (/vehicles/{id}/trip-fuel-cost) reste la seule source. On ne formate que ce qu'il renvoie.

// Coût XPF arrondi à l'unité, espace insécable fin comme séparateur de milliers : "3 240 F".
export const fmtXPF = (n) => {
  if (n == null) return "—";
  return `${Math.round(n).toLocaleString("fr-FR").replace(/[\u00A0\u202F]/g, " ")} F`;
};

// Libellé court + info-bulle pour un coût indisponible (raisons renvoyées par le backend).
const REASONS = {
  no_can: { label: "Sans CAN", hint: "Aucune donnée CANbus exploitable sur ce trajet : coût non calculable." },
  no_counter: { label: "Compteur indispo.", hint: "CAN présent mais compteur de consommation non exploitable (reset ou absent)." },
  no_price: { label: "Prix non défini", hint: "Aucun tarif carburant configuré pour ce véhicule ou cette société." },
  not_fuel: { label: "Électrique", hint: "Véhicule électrique : le coût carburant n'est pas applicable." },
};

export const fuelReason = (reason) => REASONS[reason] || { label: "Indisponible", hint: "Coût carburant indisponible." };

// Clé de jointure trajet <-> coût : identique entre /trips, /fleet-trips et /trip-fuel-cost
// car la segmentation (speed>3, break 120s) et donc le timestamp `start` sont partagés.
export const fuelKey = (vehicleId, start) => `${vehicleId || ""}|${start || ""}`;

// Info-bulle d'un coût DISPONIBLE : litres + prix + rappel « prix actuel ».
export const fuelCostHint = (cell) => {
  if (!cell) return "";
  const parts = [];
  if (cell.liters_consumed != null) parts.push(`${cell.liters_consumed} L (compteur CAN)`);
  if (cell.price != null) parts.push(`× ${Math.round(cell.price).toLocaleString("fr-FR").replace(/[\u00A0\u202F]/g, " ")} ${cell.price_unit || "XPF/L"}`);
  parts.push("Prix actuel configuré (pas le prix au moment du trajet).");
  return parts.join(" · ");
};
